// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const bellossom: PokeData = {
  "id": 182,
  "name": "bellossom",
  "height": 4,
  "weight": 58,
  "base_experience": 221,
  "types": [
    PokeType.GRASS
  ],
  "api_moves": [
    "acid",
    "absorb",
    "mega-drain",
    "growth",
    "solar-beam",
    "poison-powder",
    "stun-spore",
    "sleep-powder",
    "petal-dance",
    "toxic",
    "giga-drain",
    "sweet-scent",
    "moonlight",
    "sunny-day",
    "magical-leaf",
    "leaf-blade",
    "leaf-storm",
    "quiver-dance",
    "petal-blizzard",
    "grassy-terrain",
    "moonblast"
  ],
  "moves": [
    "acid",
    "solar-beam",
    "poison-powder",
    "stun-spore",
    "moonlight",
    "sunny-day",
    "grassy-terrain",
    "moonblast",
    "overgrowth",
    "vine-whip",
    "energy-ball",
    "razor-leaf",
    "bullet-seed"
  ],
  "evolution_chain": {
    "id": 18,
    "item": null,
    "species": [
      {
        "name": "oddish",
        "order": 47,
        "types": [
          PokeType.GRASS,
          PokeType.POISON
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "gloom",
        "order": 48,
        "types": [
          PokeType.GRASS,
          PokeType.POISON
        ],
        "evolves_from_species_id": 43,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 21,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "vileplume",
        "order": 49,
        "types": [
          PokeType.GRASS,
          PokeType.POISON
        ],
        "evolves_from_species_id": 44,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "leaf-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      },
      {
        "name": "bellossom",
        "order": 50,
        "types": [
          PokeType.GRASS
        ],
        "evolves_from_species_id": 44,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "sun-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 152,
    "speed": 88,
    "ability_power": 159
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
